import script from "./PhotoInstructionsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PhotoInstructionsPage.vue?vue&type=script&setup=true&lang=js"

import "./PhotoInstructionsPage.vue?vue&type=style&index=0&id=5b629b26&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/claims-portal/claims-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b629b26"]])

export default __exports__